export { default } from './IntroBlock'
